var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTutorialsCommunity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#bdccd4;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-tutorials-community") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.5,9a3,3,0,1,0-3-3A3,3,0,0,0,4.5,9Zm21,0a3,3,0,1,0-3-3A3,3,0,0,0,25.5,9ZM27,10.5H24a3,3,0,0,0-2.11.87,6.86,6.86,0,0,1,3.52,5.13H28.5A1.5,1.5,0,0,0,30,15V13.5A3,3,0,0,0,27,10.5Zm-12,0A5.25,5.25,0,1,0,9.75,5.25,5.25,5.25,0,0,0,15,10.5ZM18.6,12h-.39a7.25,7.25,0,0,1-6.42,0H11.4A5.4,5.4,0,0,0,6,17.4v1.35A2.25,2.25,0,0,0,8.25,21h13.5A2.25,2.25,0,0,0,24,18.75V17.4A5.4,5.4,0,0,0,18.6,12ZM8.11,11.37A3,3,0,0,0,6,10.5H3a3,3,0,0,0-3,3V15a1.5,1.5,0,0,0,1.5,1.5H4.59a6.87,6.87,0,0,1,3.53-5.13Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTutorialsCommunity);
export default __webpack_public_path__ + "static/media/icon-tutorials-community.5cb2e35ccf1250b7481c62f3234fd966.svg";
export { ForwardRef as ReactComponent };